import React from 'react';

import { SectionBanner, TopBanner } from './QalityFreeLimitsBanner.banners';
import { getRemainingTimeToMidnightUTC } from './QalityFreeLimitsBanner.util';

const REMAINING_TIME_TO_MIDNIGHT_UTC = getRemainingTimeToMidnightUTC();

type Layout = 'top-banner' | 'section-banner';

type LimitType = 'test-cycle-visibility' | 'test-case-executions';

export const LimitTitles: Record<LimitType, string> = {
  'test-case-executions': `You can’t execute this test case for next ${REMAINING_TIME_TO_MIDNIGHT_UTC}`,
};

export const LimitMessages: Partial<Record<LimitType, string>> = {
  'test-case-executions': [
    'You have reached the daily limit of 25 test case executions per Jira instance (for all projects).',
    `This means you can’t execute any test case in any project on this Jira instance for next ${REMAINING_TIME_TO_MIDNIGHT_UTC} (till 00:00 UTC).`,
  ].join(' '),
};

type Props = {
  limitType: LimitType;
  layout: Layout;
};

export default function QalityFreeLimitsBanner({
  limitType,
  layout,
}: Props): JSX.Element {
  const title = LimitTitles[limitType];
  const message = LimitMessages[limitType];

  switch (layout) {
    case 'top-banner': {
      return <TopBanner title={title} />;
    }

    case 'section-banner': {
      return <SectionBanner title={title} message={message} />;
    }

    default:
      return null;
  }
}
